( function( $ ) {
	let initBlock = function( section = false ) {

		const $section = section ? $( section ) : $( '.section-our-history' );

		$section.each( function() {
			window.app.main.customScrollbarsForSection( this );
			let $slider = $( this ).find( '.js-our-history-slider' );
			let $rolldate = $( this ).find( '.js-slider-rolldate' );

			if ( $slider[0].swiper !== undefined ) {
				if ( $slider[0].swiper ) {
					$slider[0].swiper.destroy( true, true );
				}

				if ( $rolldate[0] !== undefined && $rolldate[0].swiper !== undefined ) {
					if ( $rolldate[0].swiper ) {
						$rolldate[0].swiper.destroy( true, true );
					}
				}
			}

			let looping;

			const prepareSliderSettings = () => {
				if ( $slider.find( '.swiper-slide' ).length > 2 ) {
					looping = true;
				} else {
					looping = false;
				}
			};

			const loadSliders = () => {
				prepareSliderSettings();

				const swiperHistory = new Swiper( $slider[0], {
					speed: 1000,
					effect: 'fade',
					slidesPerView: 1,
					spaceBetween: 0,
					fadeEffect: {
						crossFade: true,
					},
					allowTouchMove: false,
					loop: looping,
					loopedSlides: 30,
					slideToClickedSlide: true,
				} );

				const swiperRolldate = new Swiper( $rolldate[0], {
					speed: 1000,
					slidesPerView: 5,
					//spaceBetween: 36,
					spaceBetween: 0,
					loop: looping,
					loopedSlides: 30,
					slideToClickedSlide: true,
					centeredSlides: true,
					centerInsufficientSlides: false,
					navigation: {
						nextEl: $slider.parents( '.section-our-history' ).find( '.swiper-button-next' )[0],
						prevEl: $slider.parents( '.section-our-history' ).find( '.swiper-button-prev' )[0],
					},
				} );

				swiperHistory.on( 'slideChange', function() {
					let activeIndex = swiperHistory.activeIndex;
					swiperRolldate.slideTo( activeIndex );
				} );

				swiperRolldate.on( 'slideChange', function() {
					let activeIndex = swiperRolldate.activeIndex;
					swiperHistory.slideTo( activeIndex );
				} );
			};

			window.app.loadVendor( 'Swiper', loadSliders );
		} );
	};

	window.app.loadBlock( initBlock, 'section-our-history', '.section-our-history' );
} )( jQuery );
